var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22",
    "data-name": "Group 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 143.169,
    height: 106.762,
    viewBox: "0 0 143.169 106.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "file-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 143.169,
    height: 106.762,
    fill: "#e761a0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#file-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M173.386,14.427V23.7h-65.01c-2.988,0-5.42-4.953-7.3-2.609l-4.778,6.016c-.552.736-2.83,5.636-3.7,5.636l-40.039,1.1V5.009A5.021,5.021,0,0,1,57.56,0h42.5A5.163,5.163,0,0,1,104.1,1.976l4.271,5.467a5.16,5.16,0,0,0,4.042,1.976h55.957a5.02,5.02,0,0,1,5.012,5.007",
    transform: "translate(-42.209)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M81.454,100.228H190.907V89.668a6.6,6.6,0,0,0-6.6-6.6H88.616a7.162,7.162,0,0,0-7.162,7.162Z",
    transform: "translate(-65.421 -66.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M143.1,112.627l-.382,2.367-.38,2.3-.765,4.875-.535,3.3L138.322,142.2l-.19,1.255-6.113,37.572a6.533,6.533,0,0,1-6.57,5.343H16.077a6.533,6.533,0,0,1-6.57-5.343L.07,122.845a6.152,6.152,0,0,1,6.342-6.92H51.8a6.534,6.534,0,0,0,5-2.293L61.536,108a6.674,6.674,0,0,1,5.044-2.293h70.177a6.151,6.151,0,0,1,6.34,6.918",
    transform: "translate(0 -79.612)",
    fill: "#e761a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.788ae6c5626142b2784869a3a3d32acd.svg";
export { ForwardRef as ReactComponent };